/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Settings_Test_ButtonInputs */

const en_admin_settings_test_button = /** @type {(inputs: Admin_Settings_Test_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Test`)
};

const zh_admin_settings_test_button = /** @type {(inputs: Admin_Settings_Test_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`测试`)
};

/**
* | output |
* | --- |
* | "Test" |
*
* @param {Admin_Settings_Test_ButtonInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_settings_test_button = /** @type {((inputs?: Admin_Settings_Test_ButtonInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Settings_Test_ButtonInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_settings_test_button(inputs)
	return zh_admin_settings_test_button(inputs)
});
export { admin_settings_test_button as "admin.settings.test.button" }